import HarvestTableContainer from './HarvestTableContainer';

export default HarvestTableContainer;
